/** @jsx jsx */
import { P, TextBlock } from "@cd2/text/build/es6"
import { css, jsx } from "@emotion/core"

import React from "react"

interface IProps {
  children: React.ReactNode
  description: React.ReactNode
  checkbox?: boolean
}

export function FieldWithDescription({ children, description, checkbox }: IProps) {
  return (
    <div
      css={css`
        display: block;
        align-items: flex-end;
      `}
    >
      <div>{children}</div>
      {description && (
        <div>
          <TextBlock size="small" color="#999">
            {typeof description === "string" ? (
              <P
                css={
                  checkbox
                    ? css`
                        margin-left: 20px !important;
                      `
                    : undefined
                }
              >
                {description}
              </P>
            ) : (
              description
            )}
          </TextBlock>
        </div>
      )}
    </div>
  )
}
